import { useEffect, useState } from 'react';

import useDataService from '../../hooks/useDataService';
import apiToUrlMap, { formatString } from '../../ApiMapping';

import {
  ISourceOrder,
  IPurchaseOrdersResponse,
  ITestProvider,
} from '../../views/PxwProcessDevices/types';
import { eMessageType } from '../../types/IMessageType';

export interface IOptionsState {
  testProviders: ITestProvider[];
  sources: ISourceOrder[];
  isLoading: boolean;
}

const INITIAL: IOptionsState = { testProviders: [], sources: [], isLoading: false };

export const usePxwSelectionOptions = (selectedTenant: string | null) => {
  const [options, setOptions] = useState<IOptionsState>(INITIAL);
  const { fetchUrl, openSnackBar } = useDataService();

  useEffect(() => {
    setOptions({ ...INITIAL, isLoading: !!selectedTenant });
    if (!selectedTenant) return;

    const load = async () => {
      try {
        const result: IPurchaseOrdersResponse = await fetchUrl(
          'GET',
          formatString(apiToUrlMap.pxwDeviceTestSandboxSources, { tenantId: selectedTenant })
        );
        setOptions({
          testProviders: result.testProviders ?? [],
          sources: result.sources ?? [],
          isLoading: false,
        });
      } catch (e: any) {
        openSnackBar(e.message || 'Unable to fetch purchase orders', eMessageType.error);
        setOptions((prev) => ({ ...prev, isLoading: false }));
      }
    };
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTenant]);

  return options;
};
